import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import Price from "../../components/price/price";

import { emptyCart, updateQuantity } from "./cartSlice";
import { placeOrder } from "../orders/orderSlice";
import { getAllCartItems } from "./selectors";
import styles from "./cart.module.css";

const Cart = ({ items }) => {

    const dispatch = useDispatch();

    const handleQuantityChange = (sku, quantity) => {
        if(
            (quantity === 0 && window.confirm('Remove from your basket?')) ||
            quantity > 0) {
            dispatch(updateQuantity({ sku, quantity}));
        }
    }

    const handlePlaceOrder = () => {
        dispatch(placeOrder(items));
        dispatch(emptyCart());
    }

    const haveCartItems = items.length > 0;

    return (
        <>
            <h1>Cart!</h1>
            <ul>
                {items.map(({sku, name, price, imageUrl, quantity}) => (
                    <li key={sku}>
                        <p>
                            {quantity} x SKU: {sku} - {name} -{" "}
                            
                            <Price value={price} currency={"GBP"} />
                        </p>
                        <img src={imageUrl} alt={name} width={50} />
                        <input type="number" min={0} max={99} value={quantity} onChange={(e) => handleQuantityChange(sku, parseInt(e.target.value))} />
                    </li>
                ))}
            </ul>

            <Link to="/" className={styles.continue}>Continue Shopping</Link>
            {haveCartItems && <button onClick={handlePlaceOrder}>Place Order</button>}
        </>
    )
}

const mapStateToProps = (state) => ({
    items: getAllCartItems(state)
})

export default connect(mapStateToProps, null)(Cart)